// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__1fkg5","screen":"styles_screen__3FGpT","loader":"styles_loader___5bag","navBar":"styles_navBar__b4sQn","content":"styles_content__1XWrf"};